<div class="flex flex-col w-3/5">
  <span class="text-base font-bold truncate text-text-900">
    {{ name() }}
  </span>
  <span class="text-sm truncate text-text-700">
    {{ address() }}
  </span>
</div>

<div class="flex flex-col items-end w-2/5 gap-y-1">
  @if (!accredited()) {
    <app-not-accredited-badge />
  } @else {
    <div class="flex items-center">
      <img src="star-icon.svg" class="w-5 h-5 mr-1" alt="Star Icon" />
      <span class="text-base font-bold text-text-700">
        {{ score() ? score().toFixed(2) : '0.00' }}
      </span>
    </div>
  }
  <span class="text-sm font-bold text-primary-300">
    {{ distance().toFixed(2) }} km
  </span>
</div>
